// extracted by mini-css-extract-plugin
export var details = "_j5-0";
export var inspectorPopover = "_j5-1";